import { Log } from '@fanfanlo'
import { triggerTimeoutUtils } from '../triggers/time/timeout/ITriggerTimeout.inft'
import { triggerWhenActivityInUtils } from '../triggers/app/when-activity-in/ITriggerWhenActivityIn'
import { triggerNodeTriggerUtils } from '../triggers/a11y/node-trigger/ITriggerNodeTrigger'
import { triggerScriptUtils } from '../triggers/script/script-trigger/ITriggerScript.inft'

const fileLog = new Log(false, 'initTriggers_f')
fileLog.pause = true
fileLog.childrenPaused = true

/**
 * 初始化所有 Triggers
 * 调用各个 triggerUtils.init() 完成注册
 */
export function initTriggers() {
    fileLog.log('[initTriggers] 开始初始化所有 trigger types')

    triggerTimeoutUtils.init()
    fileLog.log('[initTriggers] triggerTimeoutUtils 初始化完成')

    triggerWhenActivityInUtils.init()
    fileLog.log('[initTriggers] triggerWhenActivityInUtils 初始化完成')

    triggerNodeTriggerUtils.init()
    fileLog.log('[initTriggers] triggerNodeTriggerUtils 初始化完成')

    triggerScriptUtils.init()
    fileLog.log('[initTriggers] triggerScriptUtils 初始化完成')

    fileLog.log('[initTriggers] 所有 trigger types 初始化完成')
}
